import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "./Components/ScrollToTop";
import ErrorBoundary from "./Components/ErrorBoundary";
import NotFound from "./Components/pages/NotFound";
import AnalyticsInsightsCenter from './Components/pages/analytics-insights-center';
import MultiRoleDashboard from './Components/pages/multi-role-dashboard';
import UnifiedLandingHub from './Components/pages/unified-landing-hub';
import ReferralPerformanceCenter from './Components/pages/referral-performance-center';
import RealTimeScoutingInterface from './Components/pages/real-time-scouting-interface';
import ProgramDiscoveryEngine from './Components/pages/program-discovery-engine';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your route here */}
        <Route path="/" element={<UnifiedLandingHub />} />
        <Route path="/analytics-insights-center" element={<AnalyticsInsightsCenter />} />
        <Route path="/multi-role-dashboard" element={<MultiRoleDashboard />} />
        <Route path="/unified-landing-hub" element={<UnifiedLandingHub />} />
        <Route path="/referral-performance-center" element={<ReferralPerformanceCenter />} />
        <Route path="/real-time-scouting-interface" element={<RealTimeScoutingInterface />} />
        <Route path="/program-discovery-engine" element={<ProgramDiscoveryEngine />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
